class Accordion {
  constructor() {
    this.accordions = document.querySelectorAll('.js-accordion');
    this.init();
  }

  init() {
    if (!this.accordions) return;
    this.accordions.forEach((accordion) => {
      const summary = accordion.querySelector('.js-accordion-summary');
      const contents = accordion.querySelector('.js-accordion-contents');

      this.initSetMaxHeight(accordion, contents);

      summary.addEventListener('click', (e) => {
        e.preventDefault(); // ネイティブのopen切り替えを止める
        this.clickEvent(accordion, contents);
      });
    });
  }

  clickEvent(accordion, contents) {
    const isOpen = accordion.hasAttribute('open');
    if (isOpen) {
      this.accordionClose(accordion, contents);
    } else {
      this.accordionOpen(accordion, contents);
    }
  }

  initSetMaxHeight(accordion, contents) {
    if (accordion.hasAttribute('open')) {
      contents.style.maxHeight = `${contents.scrollHeight}px`;
    } else {
      contents.style.maxHeight = '0';
    }
  }

  accordionOpen(accordion, contents) {
    accordion.setAttribute('open', '');
    contents.style.maxHeight = `${contents.scrollHeight}px`;
  }

  accordionClose(accordion, contents) {
    contents.style.maxHeight = '0';
    contents.addEventListener('transitionend', () => {
        accordion.removeAttribute('open');
      }, { once: true });
  }
}

export default Accordion;
